import React from 'react';

import icon from '../icon.png';
import {
  Copy,
  AssignAgent,
  SectionHeader,
  CopyFromAgent,
} from '../../../components';
import { AgentFormInputs } from '../../../components/AgentForm/components';
import type { AgentDto } from '../../../services';
import type { AiModelData } from '../../../api';
import type { AgentFormType } from '../../agents/useAgents';

export type AgentFormProps = {
  children?: React.ReactNode;

  formId?: string;
  isEdit?: boolean;
  form: AgentFormType;
  onChange: (newForm: AgentFormType) => void;
  onUpdateFlow?: (newFlow: string) => Promise<any>;

  disabled?: boolean;
  updatingFlow?: boolean;
  agent?: any;
  llmModels: AiModelData[];
  ttsModels: AiModelData[];
  sttModels: AiModelData[];
  languages: OptionType[];
  ttsPrimary?: AiModelData;
  ttsBackup?: AiModelData;
  sttPrimary?: AiModelData;
  sttBackup?: AiModelData;
  llmPrimary?: AiModelData;
  llmBackup?: AiModelData;
  validity?: any;
};

export type AgentProps = AgentFormProps & {
  agent?: any;
  copying: boolean;
  editing: boolean;
  loading: boolean;
  onCopy: (id: string) => Promise<AgentDto | undefined>;
  onSubmit: () => void;
  showCopyModal: boolean;
  openCopyModal: () => void;
  closeCopyModal: () => void;
  editDisabled?: boolean;
};

export const AgentPage: React.FC<AgentProps> = ({
  form,
  formId,

  agent,
  copying,
  editing,
  loading,
  updatingFlow,

  onCopy,
  onChange,
  onSubmit,
  onUpdateFlow,
  editDisabled,
  showCopyModal,
  openCopyModal,
  closeCopyModal,
  ...rest
}) => {
  if (!form || !agent || loading) return null;

  return (
    <>
      <div className="border-b pb-lg mb-lg">
        <div className="flex gap-md flex-wrap justify-between items-center mb-md">
          <div className="flex flex-row gap-x-md">
            <div className="text-small truncate">Agent ID: {agent.id}</div>
            <Copy className="shrink-0" text={agent.id ?? ''} />
          </div>
        </div>
        <div className="flex flex-row grow">
          <img
            alt=""
            src={icon}
            className="size-24 p-sm bg-contrast mr-sm shrink-0 rounded-xs border"
          />
          <SectionHeader
            className="grow"
            label={
              <div className="flex flex-row gap-x-md">{agent.agent_name}</div>
            }
            subLabel={agent.title ?? ''}
            contentClassName="mt-auto"
            content={
              <div className="flex flex-row items-center gap-x-md">
                <AssignAgent agentId={agent.id!} />
                <CopyFromAgent
                  onCopy={onCopy}
                  copying={copying}
                  showCopyModal={showCopyModal}
                  openCopyModal={openCopyModal}
                  closeCopyModal={closeCopyModal}
                />
              </div>
            }
          />
        </div>
      </div>

      <div className="flex flex-col gap-y-md">
        <AgentFormInputs
          isEdit
          form={form}
          formId={formId}
          onChange={onChange}
          disabled={editDisabled}
          onUpdateFlow={onUpdateFlow}
          updatingFlow={updatingFlow}
          {...rest}
        />
      </div>
    </>
  );
};
